'use client';

import { Button } from '../ui/button';
import { FaFacebook } from 'react-icons/fa';

import { RiLinksFill } from 'react-icons/ri';
import { toast } from '@eliadmin/core/src/components/ui/use-toast';
import { Heading } from '../ui/heading';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

type BlogShareProps = {
  /** Absolute canonical URL of the article; falls back to the currently opened page. */
  url?: string | null;
};

function resolveShareUrl(url?: string | null) {
  if (url) return url;
  const { origin, pathname } = window.location;
  return `${origin}${pathname}`;
}

export function BlogShare({ url }: BlogShareProps) {
  const { t } = useTranslations();

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(resolveShareUrl(url));
      toast({
        title: 'Odkaz skopírovaný do schránky',
        variant: 'success',
      });
    } catch {
      toast({
        title: t('text4070'),
        variant: 'destructive',
      });
    }
  };

  const handleShare = () => {
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(resolveShareUrl(url))}`;
    window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=600');
  };

  return (
    <div className="flex w-full max-w-[926px] flex-col items-start justify-start gap-2">
      <Heading title={t('text1155')} tag="h2" visualTag="h6" center className={{ title: 'text-[#666666]' }} />
      <div className="flex w-full items-start justify-start gap-2">
        <Button aria-label="Kopírovať odkaz na článok" variant={'white'} size={'icon'} onClick={handleCopyLink}>
          <RiLinksFill size={20} className="text-foreground" />
        </Button>
        <Button aria-label="Zdieľať článok na Facebooku" variant={'white'} size={'icon'} onClick={handleShare}>
          <FaFacebook size={20} className="text-foreground" />
        </Button>
      </div>
    </div>
  );
}
